import {CustomButton} from "./buttons";
import TextArea from "antd/es/input/TextArea";
import {Card} from "antd";
import React, {useState} from "react";

interface NoteCardProps {
    text: string,
    onSave: (text: string) => void,
}

export default function NoteCard(props: NoteCardProps) {
    const [editMode, setEditMode] = useState<boolean>(false);
    const [editedText, setEditedText] = useState(props.text);

    return (
        <Card
            title={"Notizen"}
            extra={!editMode ?
                <CustomButton mode={"edit"} onClick={() => {setEditMode(true)}} />
                :
                <CustomButton mode={"save"} onClick={() => {
                    props.onSave(editedText);
                    setEditMode(false)
                }
                } />
            }
            bodyStyle={{
                padding: 10,
                minHeight: "10rem"}}
        >
            {
                editMode ?
                    <TextArea
                        style={{
                            width: "100%",
                            height: "100%",
                            minHeight: "8rem",
                            fontSize: "14px",
                            border: "none",
                            lineHeight: 1.6,
                        }}

                        onChange={(e) => setEditedText(e.target.value)}

                        value={editedText}
                    />
                    :
                    editedText.split("\n").map(p => <>{p}<br/></>)
            }
        </Card>
    )
}